import { C } from "../../lib/tokens.js";
import { Modal } from "./Modal.jsx";

export function ImageLightbox({ url, kind = "image", onClose }) {
  return (
    <Modal
      onClose={onClose}
      width="auto"
      backdropOpacity={0.75}
      cardStyle={{ background: "transparent", boxShadow: "none", padding: 0, gap: 0 }}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: -14,
          right: -14,
          width: 28,
          height: 28,
          borderRadius: "50%",
          border: "none",
          background: C.tin,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          zIndex: 1,
        }}
      >
        <span className="material-icons" style={{ fontSize: 16, color: C.fg }}>
          close
        </span>
      </button>
      {url && kind === "video" ? (
        <video
          src={url}
          controls
          style={{
            maxWidth: "90vw",
            maxHeight: "90vh",
            borderRadius: 6,
            boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
            display: "block",
            background: "#000",
          }}
        />
      ) : url && kind === "audio" ? (
        <div
          style={{
            width: 360,
            maxWidth: "90vw",
            padding: 28,
            background: C.tin,
            borderRadius: 8,
            boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 18,
          }}
        >
          <span className="material-icons" style={{ fontSize: 44, color: C.liquid }}>
            music_note
          </span>
          <audio src={url} controls style={{ width: "100%" }} />
        </div>
      ) : url && kind === "pdf" ? (
        <iframe
          src={url}
          title="PDF preview"
          style={{
            width: "80vw",
            height: "90vh",
            maxWidth: 900,
            border: "none",
            borderRadius: 6,
            boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
            display: "block",
            background: "#fff",
          }}
        />
      ) : url ? (
        <img
          src={url}
          alt="Attachment preview"
          style={{
            maxWidth: "90vw",
            maxHeight: "90vh",
            borderRadius: 6,
            boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
            display: "block",
          }}
        />
      ) : (
        <div
          style={{
            width: 320,
            height: 220,
            background: C.chrome,
            border: `1px solid ${C.mercury}`,
            borderRadius: 6,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <span className="material-icons" style={{ fontSize: 36, color: C.silver }}>
            image_not_supported
          </span>
          <span style={{ fontSize: 13, color: C.iron }}>
            Preview not available
          </span>
        </div>
      )}
    </Modal>
  );
}
